import { hasAppVersionOrHigher } from '@helsenorge/framework-utils/cookie';
import { getErInnloggetViaHnApp } from '@helsenorge/framework-utils/hn-user';
import { info } from '@helsenorge/framework-utils/logger';
import { saveCookieConsentCookie } from './cookie';
import { HNeventCookieConsentChange } from './events';
/**
 * Logg endring i brukerens cookie-samtykker
 * @param options Brukerens cookie-samtykker
 */
export const logCookieConsentChange = (options) => {
    info(`Informasjonskapsler for webanalyse er ${options.AnalyticsCookies ? 'godtatt' : 'ikke godtatt'}`);
};
/**
 * Lagre brukerens cookie-samtykker
 * @param options Brukerens cookie-samtykker
 */
export const updateCookieConsent = (options) => {
    saveCookieConsentCookie(options);
    logCookieConsentChange(options);
    HNeventCookieConsentChange(options);
};
/**
 * Sjekk om brukeren er logget inn via Helsenorge-appen og har versjon 25.11.00 eller høyere. I så fall skal appen bruke sitt eget cookiebanner.
 * @returns true dersom brukeren er logget inn via Helsenorge-appen og har versjon 25.11.00 eller høyere.
 */
export const getUseInAppCookieSettings = () => {
    return getErInnloggetViaHnApp() && hasAppVersionOrHigher('25.11.00');
};
/** Spesiell URL som gjør at appen åpner cookieinnstillinger i native app */
export const APP_COOKIE_SETTINGS_URL = 'helsenorge-app://cookie-innstillinger';
